._ApplicationContent_sh629_1 {
  position: relative;
  background-color: #d3d3d3;
}
._ApplicationContent_sh629_1 ._icon_sh629_5 {
  position: relative;
  left: 27px;
  top: 27px;
}